import React, { memo, useState, useContext } from "react";
import PropTypes from "prop-types";
import { Draggable } from "@hello-pangea/dnd";
import dayjs from "dayjs";

import Icon from "../icon/icon";

import css from "./TaskCard.module.css";
import { currencyFormatted } from "../../util";
import { LoginContext } from "../../context/login-context";
import {
  CUSTOMER_TYPE_LABELS,
  resolveCustomerType,
} from "../constants";
function TaskCard({ item, index, onClick, dragDisabled }) {
	const { state: userData } = useContext(LoginContext);

// console.log('item', item)
	
const accounts = [
		item?.account?.parent_account?.parent_account?.parent_account, 
		item?.account?.parent_account?.parent_account, 
		item?.account?.parent_account, 
		item?.account
	].filter((acct) => acct); 

	const itemFarmName = accounts?.find((acct) => acct.account_type === "FARM")?.name;
	const stratAcctName = accounts?.find((acct) => acct.account_type === "STRATEGIC_ACCOUNT")?.name;
	const subEntityNames = accounts?.filter((acct) => acct.account_type === "SUB_ENTITY")?.map((acct) => acct.name)?.join("/");
	const customerType = resolveCustomerType(item?.account);
	const customerTypeLabel = !customerType
		? "None"
		: CUSTOMER_TYPE_LABELS[customerType] || customerType;

	const [showDetails, setShowDetails] = useState(false);

  const rebateAmt = item?.rebate_amt || 0;

	function getItem(label, value, style) {
		return (
			<div className={css.item} style={style}>
				<div className={css.label}>{label}</div>
				<div className={css.value}>
					{`${value || `Unknown ${label}`} `}
				</div>
			</div>
		);
	}

	function capitalizeFirstLetter(str) {
		return str?.replace(/\w\S*/g, function (txt) {
			return txt?.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
		});
	}

	function taskCardClick(item) {
		showDetails ? onClick(item) : setShowDetails(!showDetails);
	}

	

	return (
		<Draggable
			isDragDisabled={dragDisabled}
			key={item.id}
			draggableId={item.id}
			index={index}
		>
			{(provided, snapshot) => {
				const getTotal = () => {
					const amt = item?.invoice_items?.reduce(function (
						acc,
						item
					) {
						return acc + item.quantity * item.retail_price;
					},
					0);
					return amt;
				};

				const getRebateTotal = (item) => {
					const amt = item?.invoice_items?.reduce(function (
						acc,
						item
					) {
						return (
							acc +
							(item?.eligibility === "ELIGIBLE"
								? item?.quantity *
								  (item?.retail_price * rebateAmt)
								: 0)
						);
					},
					0);
					return amt;
				};

				const header = (
					<div className={css.header}>
            <div className={css.acct}>
              <div className={css.name}>
                {stratAcctName || "Unknown Account"}
              </div>
              <div className={css.farm}>
                {itemFarmName ? <>Farm: <span className={css.emp}>{itemFarmName}</span></> : "Unknown Farm"}
              </div>
            </div>
						<div className={css.rebate}>
							Rebate: {currencyFormatted(getRebateTotal(item))}
						</div>
						{userData?.isValmontUser && (
							<>
							<hr className={css.divider} />
							<div className={css.reviewPills}>
								<span className={`${css.reviewPill} ${item?.is_aftermarket_part_review ? css.aftermarketReviewed : css.aftermarketPending}`}>
									Aftermarket
								</span>
								<span className={`${css.reviewPill} ${item?.is_machine_part_review ? css.machineReviewed : css.machinePending}`}>
									Machine
								</span>
							</div>
							</>
						)}
					</div>
				);

				const content = (
					<div className={css.content}>
						<div className={css.details}>
							{getItem("Customer Type", customerTypeLabel)}
							{getItem(
								"Sub Accounts",
								subEntityNames || "-", 
							)}
							{getItem(
								"Dealer Name",
								capitalizeFirstLetter(item?.dealer)
							)}
							{getItem(
								"Invoice Date",
								dayjs
									.utc(item?.invoice_date)
									.format("MMM DD, YYYY")
							)}
							{getItem(
								"Uploaded Date",
								dayjs
									.utc(item?.created_at)
									.format("MMM DD, YYYY")
							)}
							{getItem("Invoice Total", `${currencyFormatted(getTotal())}`)}
							{getItem("Invoice Number", item?.invoice_number || "Unknown Invoice Number")}
							{item?.description &&
								getItem(
									"Description",
									item?.description || "description",
									{ flex: "unset", width: "100%" }
								)}
							{item?.reason &&
								getItem("Reason", item?.reason || "reason", {
									flex: "unset",
									width: "100%",
								})}
						</div>
					</div>
				);

				const icon = (
					<Icon
						icon="ChevronDown"
						stroke="#667085"
						style={{
							borderRadius: "50%",
							backgroundColor: "#F2F4F7",

							display: "flex",
							justifyContent: "center",

							position: "absolute",
							inset: "auto auto -30px 50%",

							transform: `translateX(-50%) rotate(${
								showDetails ? "180deg" : "0deg"
							})`,
							transition: "transform 0.3s ease-in-out",
							textAlign: "center",

							paddingTop: showDetails ? 28 : 4,
							height: "50px",
							width: "50px",
						}}
						onClick={(e) => {
							e.stopPropagation();
							setShowDetails(!showDetails);
						}}
					/>
				);

				return (
					<div
						ref={provided.innerRef}
						{...provided.draggableProps}
						{...provided.dragHandleProps}
						className={css.taskCard}
						onClick={() => taskCardClick(item)}
					>
						{header}
						{showDetails && content}
						{icon}
					</div>
				);
			}}
		</Draggable>
	);
}

TaskCard.propTypes = {
	index: PropTypes.number,
	item: PropTypes.object,
};

export default memo(TaskCard);
